import { useEffect, useState } from 'react';
import YouTube from 'react-youtube';

export const YoutubePlayer = function ({radio, volume}) {
	const [youtubePlayer, setYoutubePlayer] = useState()

	const opts = {
		height: '390',
		width: '640',
		playerVars: {
		  autoplay: 1,
		},
	};

	const setupYoutubePlayer= (event) => {
		event.target?.playVideoAt(0);
		event.target?.unMute();
		event.target?.setVolume(volume);
		setYoutubePlayer(event.target)
	}

	useEffect(() => {
		youtubePlayer?.setVolume(volume);
	}, [volume])

	return <YouTube id='youtube-player' opts={opts} videoId={radio.id} onReady={setupYoutubePlayer} />
}
